// src/utils/loadCrisp.js
// Chat Crisp. Prima era caricata direttamente in public/index.html: ora
// passa da qui cosi' rispetta la categoria assegnata in cookieConsent.js
// e puo' essere nascosta mentre il banner cookie e' aperto (su mobile la
// bolla copriva il pulsante "Gestisci preferenze").

const CRISP_WEBSITE_ID = '339e0e2d-8f54-4b9e-9e6b-c649d344e2b3';

const coda = () => {
    if (!window.$crisp) {
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
        // Crisp chiede il consenso al trattamento dati prima del primo messaggio
        window.$crisp.push(['consent:ask']);
    }
    return window.$crisp;
};

// Le chiamate finiscono nella coda $crisp: funzionano anche prima che lo
// script sia scaricato, Crisp le esegue appena pronto.
export const nascondiCrisp = () => coda().push(['do', 'chat:hide']);
export const mostraCrisp = () => coda().push(['do', 'chat:show']);

export const loadCrisp = () => {
    coda();
    if (document.querySelector('script[src="https://client.crisp.chat/l.js"]')) return;

    const inject = () => {
        const s = document.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        document.head.appendChild(s);
    };
    // Mai prima del load della pagina: la chat non serve al primo paint
    const schedule = () => {
        if ('requestIdleCallback' in window) requestIdleCallback(inject, { timeout: 4000 });
        else setTimeout(inject, 2000);
    };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
};
